// src/app/shared/auth/keycloak/logout-service/logout.token.ts
import { InjectionToken } from '@angular/core';
import { IAuthenticatedUserService } from '@app/shared/auth/authenticated-user-service/authenticated-user-service';

export const AUTHENTICATED_USER_SERVICE = new InjectionToken<IAuthenticatedUserService>(
  'IAuthenticatedUserService',
);
